module.exports = __webpack_public_path__ + "img/wifi_One.6d9581ef.jpg";